import { Injectable } from '@angular/core';
import { ILocaleService, ILocaleConfig } from '@smsamiinc/invoice'; // Can import from any plugin
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Locale service implementation for POS application
 * Handles locale, currency, and timezone configuration
 */
@Injectable({ providedIn: 'root' })
export class LocaleService implements ILocaleService {
    private localeChange$ = new BehaviorSubject<ILocaleConfig>(this.getDefaultLocale());

    /**
     * Get the default locale configuration
     */
    private getDefaultLocale(): ILocaleConfig {
        return {
            localeId: 'en-US',
            currency: 'USD',
            currencySymbol: '$',
            timezone: 'America/New_York',
        };
    }

    getLocaleId(): string {
        return this.localeChange$.value.localeId;
    }

    getCurrency(): string {
        return this.localeChange$.value.currency;
    }

    getCurrencySymbol(): string {
        return this.localeChange$.value.currencySymbol;
    }

    getTimezone(): string {
        return this.localeChange$.value.timezone;
    }

    getConfig(): ILocaleConfig {
        return { ...this.localeChange$.value };
    }

    /**
     * Update locale configuration
     */
    setLocale(config: Partial<ILocaleConfig>): void {
        const newConfig = { ...this.localeChange$.value, ...config };
        this.localeChange$.next(newConfig);
    }

    onLocaleChange$(): Observable<ILocaleConfig> {
        return this.localeChange$.asObservable();
    }
}
